import React from 'react';
import './PackageCard.css';

const PackageCard = ({ image, title, duration, link, onPackageClick }) => {
  const handleClick = (e) => {
    if (onPackageClick) {
      e.preventDefault();
      onPackageClick();
    }
  };

  return (
    <div className="package-card" onClick={handleClick} style={{ cursor: onPackageClick ? 'pointer' : 'default' }}>
      <div className="package-image">
        <img src={image} alt={title} />
      </div>
      <div className="package-info">
        <h3>{title}</h3>
        {duration && (
          <p className="duration">
            <i className="fas fa-calendar-alt"></i> {duration}
          </p>
        )}
        {onPackageClick ? (
          <button 
            onClick={(e) => {
              e.stopPropagation(); // Prevent double-click when clicking button
              handleClick(e);
            }} 
            className="btn-view"
          >
            View Package Details
          </button>
        ) : (
          <a href={link} className="btn-view">View Tours</a>
        )}
      </div>
    </div>
  );
};

export default PackageCard;
